import { css } from 'lit';
import { hostReset } from '../styles/mixins.js';
import * as t from '../styles/tokens.js';

export default [
  hostReset,
  css`
    :host { display: block; }

    /* ── Container ───────────────────────────────────────────────────────────── */
    .uwc-bc {
      background:    var(--uwc-breadcrumb-bg,      transparent);
      border:        var(--uwc-breadcrumb-border,  none);
      border-radius: var(--uwc-breadcrumb-radius,  ${t.radiusMd});
      padding:       var(--uwc-breadcrumb-padding, 0);
    }

    /* ── List ────────────────────────────────────────────────────────────────── */
    .uwc-bc__list {
      display:     flex;
      align-items: center;
      flex-wrap:   wrap;
      list-style:  none;
      margin:      0;
      padding:     0;
      gap:         0;
    }

    /* ── Item ────────────────────────────────────────────────────────────────── */
    .uwc-bc__item {
      display:     flex;
      align-items: center;
    }

    /* ── Separator ───────────────────────────────────────────────────────────── */
    .uwc-bc__sep {
      display:     flex;
      align-items: center;
      padding:     0 var(--uwc-breadcrumb-sep-gap, ${t.space2});
      color:       var(--uwc-breadcrumb-separator-color, ${t.textMuted});
      user-select: none;
      flex-shrink: 0;
    }
    .uwc-bc__sep-text,
    .uwc-bc__sep-icon {
      display:     inline-flex;
      align-items: center;
      font-size:   var(--uwc-breadcrumb-item-font-size, ${t.fontSizeSm});
      line-height: 1;
    }

    /* ── Link / button base ──────────────────────────────────────────────────── */
    .uwc-bc__link {
      display:         inline-flex;
      align-items:     center;
      gap:             ${t.space1};
      font-size:       var(--uwc-breadcrumb-item-font-size,   ${t.fontSizeSm});
      font-weight:     var(--uwc-breadcrumb-item-font-weight, ${t.fontWeightMedium});
      font-family:     var(--uwc-font-family, inherit);
      color:           var(--uwc-breadcrumb-item-color,       ${t.textSecondary});
      text-decoration: none;
      border-radius:   ${t.radiusSm};
      padding:         2px ${t.space1};
      border:          none;
      background:      transparent;
      cursor:          pointer;
      outline:         none;
      white-space:     nowrap;
      transition:
        color      ${t.durationFast} ${t.easingStandard},
        background ${t.durationFast} ${t.easingStandard};
    }

    /* Interactive hover — anchors and non-disabled buttons only */
    a.uwc-bc__link:hover,
    button.uwc-bc__link:not([disabled]):hover {
      color:      var(--uwc-breadcrumb-item-hover-color,
        var(--uwc-color-primary, ${t.primary}));
      background: var(--uwc-breadcrumb-item-hover-bg,
        color-mix(in oklab, var(--uwc-color-primary, ${t.primary}) 8%, transparent));
    }

    a.uwc-bc__link:focus-visible,
    button.uwc-bc__link:focus-visible {
      outline:        2px solid var(--uwc-color-primary, ${t.primary});
      outline-offset: 1px;
    }

    /* ── Current page (last item) ────────────────────────────────────────────── */
    .uwc-bc__link--current {
      color:          var(--uwc-breadcrumb-active-item-color,
        var(--uwc-text, ${t.text}));
      font-weight:    var(--uwc-breadcrumb-active-item-font-weight, ${t.fontWeightSemibold});
      cursor:         default;
      pointer-events: none;
    }

    /* ── Disabled item ───────────────────────────────────────────────────────── */
    .uwc-bc__link--disabled {
      color:          var(--uwc-breadcrumb-item-disabled-color, ${t.textDisabled});
      cursor:         not-allowed;
      pointer-events: none;
    }

    /* ── Home item ───────────────────────────────────────────────────────────── */
    .uwc-bc__link--home {
      color: var(--uwc-breadcrumb-home-color, ${t.textSecondary});
    }

    /* ── Sub-elements ────────────────────────────────────────────────────────── */
    .uwc-bc__icon {
      display:     inline-flex;
      align-items: center;
      flex-shrink: 0;
    }
    .uwc-bc__label { line-height: 1.2; }

    /* ── Reduced motion ──────────────────────────────────────────────────────── */
    @media (prefers-reduced-motion: reduce) {
      .uwc-bc__link { transition: none; }
    }
  `,
];
